(() => {
  if (window.__moduBundleCartQuantity) return;
  window.__moduBundleCartQuantity = true;
  const selector = '[data-modu-bundle-group]';
  const busy = new Set();
  const clean = value => typeof value === 'string' ? value.trim() : '';
  const variantNumber = value => {
    const tail = String(value || '').split('/').pop();
    const number = Number(tail);
    return Number.isSafeInteger(number) && number > 0 ? number : null;
  };
  const route = path => (window.Shopify?.routes?.root || '/') + path;
  const surface = root => root.closest('cart-drawer, .cart-page') || document;
  const activeRoot = root => root.dataset.moduPlacement === 'mobile' ? matchMedia('(max-width: 699px)').matches : root.dataset.moduPlacement === 'desktop' ? !matchMedia('(max-width: 699px)').matches : true;
  const group = root => [...surface(root).querySelectorAll(selector)].filter(node => activeRoot(node) && node.dataset.moduBundleGroup === root.dataset.moduBundleGroup);
  const row = root => root.closest('tr') || root.closest('line-item');
  const sections = () => {
    const result = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: result } }));
    return [...new Set(result)];
  };
  const formatPrice = cents => new Intl.NumberFormat(window.Shopify?.locale || undefined, {
    style: 'currency', currency: window.Shopify?.currency?.active || 'USD'
  }).format(cents / 100);

  function template(root) {
    try {
      return JSON.parse(root.querySelector('[data-modu-unit-template]')?.textContent || '');
    } catch {
      return null;
    }
  }

  function verifiedUnit(root) {
    const data = template(root);
    if (!data || data.quantityMode !== 'unit-group-v1' ||
        typeof data.unitComponents !== 'string' || data.unitComponents.length > 2048 ||
        !clean(data.definitionId) || !clean(data.groupId) ||
        !clean(data.parentVariantId) || !clean(data.configurationVersion) ||
        data.groupId !== root.dataset.moduBundleGroup || !clean(root.dataset.moduParentKey) ||
        !Array.isArray(data.components)) return null;
    let selected;
    try { selected = JSON.parse(data.unitComponents); } catch { return null; }
    if (!Array.isArray(selected) || !selected.length || selected.length !== data.components.length) return null;
    const current = new Map();
    for (const component of data.components) {
      if (!clean(component.componentId) || !variantNumber(component.variantId) ||
          !Number.isSafeInteger(component.quantity) || component.quantity < 1 ||
          current.has(component.componentId)) return null;
      current.set(component.componentId, component);
    }
    const seen = new Set();
    for (const component of selected) {
      const child = current.get(component?.componentId);
      if (!child || seen.has(component.componentId) || !clean(component.variantId) ||
          !Number.isSafeInteger(component.quantity) || component.quantity < 1 ||
          !variantNumber(component.variantId) ||
          variantNumber(component.variantId) !== variantNumber(child.variantId) ||
          component.quantity !== child.quantity) return null;
      seen.add(component.componentId);
    }
    return { ...data, selected };
  }

  function verifiedGroup(units) {
    if (!units.length) return null;
    const first = verifiedUnit(units[0]);
    if (!first) return null;
    const keys = new Set();
    for (const unit of units) {
      const value = verifiedUnit(unit);
      const key = unit.dataset.moduParentKey;
      if (!value || value.unitComponents !== first.unitComponents ||
          value.definitionId !== first.definitionId ||
          value.parentVariantId !== first.parentVariantId ||
          value.configurationVersion !== first.configurationVersion ||
          keys.has(key)) return null;
      keys.add(key);
    }
    return first;
  }

  function mount(container = document) {
    const seen = new Set();
    container.querySelectorAll(selector).forEach(root => {
      if (!activeRoot(root)) return;
      const key = root.dataset.moduBundleGroup;
      const scope = surface(root);
      const groupKey = key + ':' + (scope.tagName || 'document');
      if (!key || seen.has(groupKey)) return;
      seen.add(groupKey);
      const units = group(root);
      units.forEach((unit, index) => { const itemRow = row(unit); if (itemRow) itemRow.hidden = index > 0; });
      const first = units[0];
      const valid = verifiedGroup(units);
      const stepper = first.querySelector('[data-modu-stepper]');
      const guidance = first.querySelector('[data-modu-legacy-guidance]');
      if (stepper) stepper.hidden = !valid;
      if (guidance) guidance.hidden = !!valid;
      if (valid) {
        first.querySelector('[data-modu-logical-quantity]').textContent = String(units.length);
        first.querySelector('[data-modu-quantity-change="-1"]').disabled = units.length <= 1 || busy.has(key);
        first.querySelector('[data-modu-quantity-change="1"]').disabled = busy.has(key);
      } else {
        const output = first.querySelector('[data-modu-logical-quantity]');
        if (output) output.textContent = '';
      }
      const quantities = new Map();
      units.forEach(unit => row(unit)?.querySelectorAll('[data-modu-component-quantity]').forEach(node => {
        const id = node.dataset.componentId;
        quantities.set(id, (quantities.get(id) || 0) + Number(node.dataset.unitQuantity || 0));
      }));
      row(first)?.querySelectorAll('[data-modu-component-quantity]').forEach(node => {
        node.textContent = (window.themeVariables?.strings?.quantity || 'Quantity') + ': ' + (quantities.get(node.dataset.componentId) || node.dataset.unitQuantity);
      });
      const total = units.reduce((sum, unit) => sum + Number(unit.dataset.unitPrice || 0), 0);
      row(first)?.querySelectorAll('[data-modu-group-price]').forEach(node => { node.textContent = formatPrice(total); });
    });
  }

  function newUnit(data) {
    if (!data) return null;
    const id = crypto.randomUUID();
    const items = data.selected.map(component => ({
      id: variantNumber(component.variantId),
      quantity: component.quantity,
      properties: {
        _bundle_definition_id: data.definitionId,
        _bundle_id: id,
        _bundle_group_id: data.groupId,
        _bundle_component_id: component.componentId,
        _bundle_parent_variant_id: data.parentVariantId,
        _bundle_configuration_version: data.configurationVersion,
        _bundle_quantity_mode: 'unit-group-v1',
        _bundle_unit_components: data.unitComponents
      }
    }));
    return items.every(item => item.id && item.quantity > 0) ? items : null;
  }

  async function request(path, body) {
    const response = await fetch(route(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: sections().join(','), sections_url: location.pathname })
    });
    const payload = await response.json();
    if (!response.ok || payload.errors) throw new Error('Cart update failed');
    const cart = path === 'cart/add.js' ? await (await fetch(route('cart.js'))).json() : payload;
    cart.sections = payload.sections || {};
    if (window.themeVariables?.settings?.pageType === 'cart') {
      location.reload();
    } else {
      const refreshed = new Promise(resolve => {
        const timeout = setTimeout(resolve, 5000);
        document.addEventListener('cart-drawer:refreshed', () => { clearTimeout(timeout); resolve(); }, { once: true });
      });
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'cart:change', cart } }));
      await refreshed;
    }
  }

  async function mutate(root, action) {
    const key = root.dataset.moduBundleGroup;
    if (!key || busy.has(key)) return;
    const units = group(root);
    const valid = verifiedGroup(units);
    if (action !== 'remove' && !valid) return;
    busy.add(key);
    document.querySelectorAll(selector).forEach(node => {
      if (node.dataset.moduBundleGroup === key) node.querySelectorAll('button').forEach(button => { button.disabled = true; });
    });
    try {
      if (action === 'add') {
        const items = newUnit(valid);
        if (!items) throw new Error('Incomplete bundle composition');
        await request('cart/add.js', { items });
      } else if (action === 'minus' && units.length > 1) {
        await request('cart/change.js', { id: units.at(-1).dataset.moduParentKey, quantity: 0 });
      } else if (action === 'remove') {
        await request('cart/update.js', { updates: Object.fromEntries(units.map(unit => [unit.dataset.moduParentKey, 0])) });
      }
    } catch (error) {
      const status = root.querySelector('[data-modu-quantity-status]');
      if (status) status.textContent = 'Unable to update this bundle.';
      throw error;
    } finally {
      busy.delete(key);
      document.querySelectorAll(selector).forEach(node => {
        if (node.dataset.moduBundleGroup === key) node.querySelectorAll('button').forEach(button => { button.disabled = false; });
      });
      mount(document);
    }
  }

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-modu-quantity-change], [data-modu-bundle-remove]');
    const root = button?.closest(selector);
    if (!root) return;
    event.preventDefault();
    const action = button.hasAttribute('data-modu-bundle-remove') ? 'remove' : button.dataset.moduQuantityChange === '1' ? 'add' : 'minus';
    mutate(root, action).catch(() => {});
  });
  document.addEventListener('cart-drawer:refreshed', () => mount(document));
  window.addEventListener('resize', () => mount(document));
  mount(document);
})();